if(navigator.platform !="Linux x86_64"){

document.addEventListener("DOMContentLoaded", function(event) { 
class XlsExport {
  // data: array of objects with the data for each row of the table
  // name: title for the worksheet
  constructor(data, title = 'Worksheet', btn) {
    // input validation: new xlsExport([], String)
    if (!Array.isArray(data) || (typeof title !== 'string' || Object.prototype.toString.call(title) !== '[object String]')) {
      throw new Error('Invalid input types: new xlsExport(Array [], String)');
    }

    this._data = data;
    this._title = title;
    this._btn = btn;
  }

  set setData(data) {
    if (!Array.isArray(data)) throw new Error('Invalid input type: setData(Array [])');

    this._data = data;
  }

  get getData() {
    return this._data;
  }

  exportToXLS(fileName = 'export.xlsx') {
    if (typeof fileName !== 'string' || Object.prototype.toString.call(fileName) !== '[object String]') {
      throw new Error('Invalid input type: exportToCSV(String)');
    }
    console.log('enterfile test slkdf');
    const TEMPLATE_XLS = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>`;
    const MIME_XLS = 'data:application/vnd.ms-excel;charset=UTF-8;base64,';

    const parameters = {
      title: this._title,
      table: this.objectToTable(),
    };
    const computeOutput = TEMPLATE_XLS.replace(/{(\w+)}/g, (x, y) => parameters[y]);

    const computedXLS = new Blob([computeOutput], {
      type: MIME_XLS,
    });
    const xlsLink = window.URL.createObjectURL(computedXLS);
    var btn = this._btn;
    this.downloadFile(xlsLink, fileName, btn);
  }

  exportToCSV(fileName = 'export.csv') {
    if (typeof fileName !== 'string' || Object.prototype.toString.call(fileName) !== '[object String]') {
      throw new Error('Invalid input type: exportToCSV(String)');
    }
    const computedCSV = new Blob([this.objectToSemicolons()], {
      type: 'text/csv;charset=utf-8',
    });
    const csvLink = window.URL.createObjectURL(computedCSV);
    
    var btn = this._btn;
    this.downloadFile(csvLink, fileName, btn);
  }

  downloadFile(output, fileName, btn) {
    if(btn=="btn")
    {
    	var link = document.getElementById('download_csv_btn');
    	link.setAttribute('download', fileName);
    	link.href = output;
    }
    else{
    	
      jQuery('.supports-js body.page-fade.unloading').css('opacity','1');	
      var link1 = document.getElementById('download_csv_btn1');
        var link2 = document.getElementById('download_csv_btn2');
      
    	link1.setAttribute('download', fileName);
    	link1.href = output;
        link2.href = output;
      
       let html = '<a href="'+output+'" id="download_csv_btn_file" download="CLNF-Shopping-Cart">click here to Download Cart</a>';
       
       document.getElementById('generate_link').innerHTML = html;
       
      
    }
  }

  toBase64(string) {
    return window.btoa(unescape(encodeURIComponent(string)));
  }

  objectToTable() {
    // extract keys from the first object, will be the title for each column
    const colsHead = `<tr>${Object.keys(this._data[0]).map(key => `<td>${key}</td>`).join('')}</tr>`;
	
    const colsData = this._data.map(obj => [`<tr>
                ${Object.keys(obj).map(col => col=='Item Number' ? `<td style="mso-number-format:'\@';">${obj[col] ? obj[col] : ''}</td>` : `<td>${obj[col] ? obj[col] : ''}</td>`   ).join('')}
            </tr>`]) // 'null' values not showed
      .join('');

    return `<table>${colsHead}${colsData}</table>`.trim(); // remove spaces...
  }
  

  objectToSemicolons() {
    console.log(this._data[0]);
    const colsHead = Object.keys(this._data[0]).map(key => [key]);
    const colsData = this._data.map(obj => [ 
      Object.keys(obj).map(col => [
        (col=='Item Number')?'="'+obj[col]+'"':obj[col],
      ]) 
    ]).join('\n'); // end of row

    return `${colsHead}\n${colsData}`;
  }
  
}
  
  
    /*function exportCsv() {
       var table = document.getElementById('cart_item_table');
       var data = [];
       data.push(['Item Number', 'Product', 'Quantity', 'Price', 'ExtendedPrice']);

       jQuery.getJSON('/cart.js', function(cart) {

         var cartitems = cart.items;
         for (var key in cartitems) {
            var item = cartitems[key];
            var item_number =  item.sku.toString();
            var item_title = item.title.replace(/,/g, ' | ');
            var description = item.product_description;
            var item_qty =  item.quantity;
            var price =  (item.price)/100;
            price = price.toFixed(2);
            var ext_price = item_qty*price;
            var newArr = [item_number,item_title, item_qty, price, ext_price];
            data.push(newArr);  
         }

       }).done(function() {
		console.log(data);
          var csvContent = "data:text/csv;charset=utf-8,";
           data.forEach(function(infoArray, index) {
             dataString = infoArray.join(',');
             csvContent += index < data.length ? dataString + '\n' : dataString;
           });
         var encodedUri = encodeURI(csvContent);
         var link = document.getElementById('download_csv_btn');
         link.setAttribute('href', encodedUri);
         link.setAttribute('download', 'CLNF Shopping Cart.csv');

      })

    };

  	//exportCsv();*/
  
  var exportdata = [];
  var excel_data = [];
  var excel_html ="";
	jQuery.getJSON('/cart.js', function(cart) {

         var cartitems = cart.items;
         for (var key in cartitems) {
            var item = cartitems[key];
            var item_number =  item.sku.toString();
            var item_title = item.title.replace(/,/g, ' | ');
            var description = item.product_description;
            var item_qty =  item.quantity;
            var price =  (item.price)/100;
            price = price.toFixed(2);
            var ext_price = item_qty*price;
            var newArr = {"Item Number":item_number, "Product":item_title, "Quantity":item_qty, "Price":price,"ExtendedPrice": ext_price};
            var newexcelArr = {"ItemNumber":item_number, "Product":item_title, "Quantity":item_qty, "Price":price,"ExtendedPrice": ext_price};
            exportdata.push(newArr); 
            excel_data.push(newexcelArr);
         }

       }).done(function() {
      	
			
      		 excel_data.forEach( function(item){
                 excel_html +=  `<tr> <td>`+item.ItemNumber+`</td>  <td> <p>`+item.Product+`</p> </td> <td>`+item.Quantity+`</td> <td>`+item.Price+`</td> <td>`+item.ExtendedPrice+`</td> </tr>`;
			  })
              
             document.querySelector('#tbl_exporttable_to_xls tbody').innerHTML = excel_html;
      
      		if(jQuery('body').hasClass('template-cart')){
                         
            	const xls = new XlsExport(exportdata, 'Example WB', 'btn');
    			document.querySelector('#download_csv_btn').addEventListener('click', function() { xls.exportToXLS('CLNF-Shopping-Cart.xlsx') });
      		}
      
      })
    
    
    // Improved cart download functionality with proper error handling and debouncing
    let isDownloading = false;
    let downloadRetryCount = 0;
    const maxRetries = 3;
    
    function updateDownloadStatus(message, isError = false) {
        const generateLink = document.getElementById('generate_link');
        if (generateLink) {
            generateLink.innerHTML = message;
            generateLink.style.color = isError ? '#d32f2f' : '#2e7d32';
            generateLink.style.display = 'block';
        }
    }
    
    function resetDownloadButton() {
        const downloadBtn = document.getElementById('download_csv_btn1');
        if (downloadBtn) {
            downloadBtn.disabled = false;
            downloadBtn.style.opacity = '1';
            downloadBtn.style.cursor = 'pointer';
        }
        isDownloading = false;
    }
    
    function disableDownloadButton() {
        const downloadBtn = document.getElementById('download_csv_btn1');
        if (downloadBtn) {
            downloadBtn.disabled = true;
            downloadBtn.style.opacity = '0.6';
            downloadBtn.style.cursor = 'not-allowed';
        }
        isDownloading = true;
    }
    
    function processCartData(cart) {
        try {
            var dwncart = [];
            var cartitems = cart.items;
            
            if (!cartitems || cartitems.length === 0) {
                throw new Error('Cart is empty');
            }
            
            for (var key in cartitems) {
                var item = cartitems[key];
                var item_number = item.sku ? item.sku.toString() : 'N/A';
                var item_title = item.title ? item.title.replace(/,/g, ' | ') : 'Unknown Product';
                var item_qty = item.quantity || 0;
                var price = item.price ? (item.price)/100 : 0;
                price = price.toFixed(2);
                var ext_price = item_qty * price;
                
                var newArr = {
                    "Item Number": item_number, 
                    "Product": item_title, 
                    "Quantity": item_qty, 
                    "Price": price,
                    "ExtendedPrice": ext_price
                };
                dwncart.push(newArr);
            }
            
            return dwncart;
        } catch (error) {
            console.error('Error processing cart data:', error);
            throw error;
        }
    }
    
    function triggerDownload(cartData) {
        try {
            const xls1 = new XlsExport(cartData, 'Example WB', 'btn1');
            xls1.exportToCSV('CLNF-Shopping-Cart.csv');
            
            // Verify download was triggered
            setTimeout(() => {
                updateDownloadStatus('✅ Download completed successfully!');
                setTimeout(() => {
                    document.getElementById('generate_link').style.display = 'none';
                }, 2000);
            }, 500);
            
        } catch (error) {
            console.error('Error triggering download:', error);
            throw error;
        }
    }
    
    function attemptDownload() {
        if (isDownloading) {
            console.log('Download already in progress, ignoring click');
            return;
        }
        
        disableDownloadButton();
        updateDownloadStatus('🔄 Preparing cart download...');
        
        jQuery.getJSON('/cart.js')
            .done(function(cart) {
                try {
                    const cartData = processCartData(cart);
                    updateDownloadStatus('📥 Generating download file...');
                    
                    // Small delay to ensure DOM is ready
                    setTimeout(() => {
                        triggerDownload(cartData);
                        resetDownloadButton();
                        downloadRetryCount = 0; // Reset retry count on success
                    }, 300);
                    
                } catch (error) {
                    console.error('Error processing cart:', error);
                    updateDownloadStatus('❌ Error processing cart data: ' + error.message, true);
                    resetDownloadButton();
                }
            })
            .fail(function(xhr, status, error) {
                console.error('Failed to fetch cart data:', error);
                
                if (downloadRetryCount < maxRetries) {
                    downloadRetryCount++;
                    updateDownloadStatus(`🔄 Retry ${downloadRetryCount}/${maxRetries} - Fetching cart data...`);
                    
                    setTimeout(() => {
                        attemptDownload();
                    }, 1000 * downloadRetryCount); // Exponential backoff
                } else {
                    updateDownloadStatus('❌ Failed to download cart after multiple attempts. Please try again later.', true);
                    resetDownloadButton();
                    downloadRetryCount = 0;
                }
            });
    }
    
    // Debounced click handler
    jQuery(document).on('click', '#download_csv_btn1', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        if (isDownloading) {
            return false;
        }
        
        attemptDownload();
        return false;
    });
    
    
      
    
    
      

});

}